import _toConsumableArray from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray";
import _typeof from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/helpers/typeof";
import _asyncToGenerator from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator";
import _regeneratorRuntime from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/regenerator";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.number.constructor.js";
import "core-js/modules/es6.regexp.replace.js";
import "core-js/modules/es6.array.slice.js";
import "core-js/modules/es6.function.name.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.from.js";
import "core-js/modules/es6.string.iterator.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.array.find.js";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.string.includes.js";
import "core-js/modules/es7.array.includes.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { get } from 'vuex-pathify';
import { FIB } from '@/config/constants';
import Logger from 'js-logger';
import { answersUpdated, questionsStarted, skipSection, surveySubmitted } from "../boot/google-analytics";
export default {
  name: 'Questions',
  components: {
    FibCommonModal: require('@/components/CommonModal').default
  },
  data: function data() {
    return {
      currentViewableScreen: 0,
      nextScreenTriggerLoading: false,
      lastQuestionInView: false,
      latestScreenIndex: 0,
      showPinnedHeader: false,
      validScreens: {},
      showResubmitModal: false
    };
  },
  computed: {
    screens: get('questions/getScreens'),
    completedScreens: get('questions/completedScreens'),
    responseSending: get('responses/sending'),
    responseFailedSubmit: get('responses/failedToSubmit'),
    companyDetails: get('config/getCompanyDetails'),
    currentSurvey: get('surveys/currentSurvey'),
    branchDetails: get('config/getBranchDetails'),
    answers: get('answers/responses'),
    answeredSections: get('answers/responsesSections'),
    totalQuestionsCount: get('questions/getQuestionsCount'),
    isApp: get('config/isApp'),
    // Bring in the colour scheme for the error modal icon
    iconColour: function iconColour() {
      return this.$store.getters['theme/theme'].dangerColor;
    },
    // check out: responseSubmitted: get('responses/submitted'),
    screensToDisplay: function screensToDisplay() {
      var _this = this;

      if (!Array.isArray(this.screens)) {
        return [];
      }

      return this.screens.filter(function (screen, index) {
        return index <= _this.latestScreenIndex;
      });
    },
    latestScreen: function latestScreen() {
      return this.screens[this.latestScreenIndex];
    },
    latestScreenInView: function latestScreenInView() {
      return this.currentViewableScreen === this.screensToDisplay.length - 1;
    },
    finalScreenIndex: function finalScreenIndex() {
      return this.screens.length - 1;
    },
    getQuizFlowHeaderTitle: function getQuizFlowHeaderTitle() {
      return this.screens && this.screens[this.currentViewableScreen] ? this.screens[this.currentViewableScreen].title : '';
    },
    nextButtonDisabled: function nextButtonDisabled() {
      if (!this.latestScreen) {
        return false;
      } // This just prevents a load of errors in the case that there are no questions.


      if (this.userCanSkip) {
        return false;
      }

      if (!this.requiredQuestionsAnswered) {
        return true;
      }

      return false;
    },
    userCanSkip: function userCanSkip() {
      var _this$screens$this$cu;

      return ((_this$screens$this$cu = this.screens[this.currentViewableScreen]) === null || _this$screens$this$cu === void 0 ? void 0 : _this$screens$this$cu.userCanSkip) || false;
    },
    screenHeight: function screenHeight() {
      return window.innerHeight - 110 + 'px';
    },
    brandedSectionHeight: function brandedSectionHeight() {
      var brandedSection = document.querySelector('.main-layout__foreground');
      var brandedSectionHeight = window.getComputedStyle(brandedSection, null).getPropertyValue('padding-top');

      if (!brandedSectionHeight) {
        return 0;
      }

      return Number(brandedSectionHeight.replace('px', ''));
    },
    requiredQuestionsAnswered: function requiredQuestionsAnswered() {
      var _this2 = this;

      // Check not only that required questions on the last screen visible have been answered -
      // but that required questions on *all* previous screens have been answered. This prevents
      // people putting in dummy answers for required questions then coming back later and
      // removing them, invalidating the required condition.
      return this.screens.slice(0, this.latestScreenIndex + 1).every(function (screen) {
        return _this2.requiredQuestionAnswered(screen);
      });
    },
    responsesUpdated: function responsesUpdated() {
      return this.$store.getters['answers/responsesUpdated'] || 0;
    },
    allowImageUpload: function allowImageUpload() {
      return this.$store.getters['surveys/currentSurvey'].appAllowImageUpload;
    }
  },
  watch: {
    responseFailedSubmit: function responseFailedSubmit(val) {
      this.showResubmitModal = val;
    },
    responsesUpdated: function responsesUpdated() {
      var _this$$store$getters$;

      this.validateScreens(); // GTM questions started

      var name = this.companyDetails.name;
      var _this$currentSurvey = this.currentSurvey,
          surveyId = _this$currentSurvey.surveyId,
          surveyTypeId = _this$currentSurvey.surveyTypeId;
      var branchId = this.branchDetails.id;
      var answeredCount = Object.keys(this.answers).length;
      answersUpdated({
        companyName: name,
        surveyId: surveyId,
        surveyTypeId: surveyTypeId,
        answeredCount: answeredCount,
        branchId: branchId,
        isPveUser: !!((_this$$store$getters$ = this.$store.getters['checkIn/urlParams']) !== null && _this$$store$getters$ !== void 0 && _this$$store$getters$.pve)
      });
    },
    screensToDisplay: function screensToDisplay() {
      this.validateScreens();
    },
    // If the responseSending previous value is true and the response hasn't failed (responseFailedSubmit) then we want to proceed to checkout.
    responseSending: function responseSending(val, oldVal) {
      if (oldVal && !this.responseFailedSubmit) {
        // If the ability for the user to upload an image to the survey is defined in the survey configuration then before submitting the survey responses, we need to direct them to the upload page to be able to upload an image if they choose
        if (this.allowImageUpload) {
          Logger.debug('Final screen - Go to image upload');
          this.$router.push('/upload'); // Redirect to index page

          return;
        } else {
          // if they are already on the final screen, go to the checkout flow
          Logger.debug('Final screen - Go to checkout');
          this.$router.push('/checkout');
        }
      }
    }
  },
  mounted: function mounted() {
    var _this$$store$getters$2,
        _this3 = this;

    // These helpers should always be left commented out at commit - perform these operations at survey start only
    this.$store.commit('answers/resetState');
    this.$store.commit('questions/resetState');
    Logger.debug('clearing menu items');

    if (!this.isApp) {
      this.$store.commit('products/resetState');
    } // GTM questions started


    var name = this.companyDetails.name;
    var _this$currentSurvey2 = this.currentSurvey,
        surveyId = _this$currentSurvey2.surveyId,
        surveyTypeId = _this$currentSurvey2.surveyTypeId,
        sections = _this$currentSurvey2.sections;
    var branchId = this.branchDetails.id;
    questionsStarted({
      companyName: name,
      surveyId: surveyId,
      surveyTypeId: surveyTypeId,
      sectionsTotal: sections.length,
      branchId: branchId,
      isPveUser: !!((_this$$store$getters$2 = this.$store.getters['checkIn/urlParams']) !== null && _this$$store$getters$2 !== void 0 && _this$$store$getters$2.pve)
    });
    window.addEventListener('scroll', this.handleScroll); // Ensure we attempt to apply screen & question selection at the start, to handle the case that the initial screens are question screens.
    //   We wrap this in a loader in the case that question selection is normally run this early (you'd have to have nps and ratings
    // on display after questions or both off, which makes no sense). But if it is, at least we're showing the loader so you don't see
    // invalid questions until it's done.
    //   In the case that question selection isn't run now, you won't even see the loader as this will be synchronous, so all's well!

    this.$loading( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this3.$store.dispatch('questions/initialiseScreens');

            case 2:
              return _context.abrupt("return", _context.sent);

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));
  },
  methods: {
    // Test if all required questions have been answered for a given screen.
    requiredQuestionAnswered: function requiredQuestionAnswered(screen) {
      // TODO: Ideally we would change to check for presence of the question id in this.$store.getters['answers/answers'] - as the below
      // doesn't seem to work for complex, composite questions (such as MenuInsight) as the logic below can't understand their structure,
      // whereas this.$store.getters['answers/answers'] contains the parsed, understood data.
      // If the user can skip the entire section / question, then it should be considered answered.
      if (screen.userCanSkip) {
        return true;
      } // get screen questions


      var questions = screen.questions; // for all questions on screen, filter out those not required

      var required = questions.filter(function (q) {
        return q.required;
      }); // if none required, return true

      if (!required.length) {
        return true;
      } // cycle through each required question, if in any case a valid response cannot be found, return false


      for (var i in required) {
        var _required$i$_meta$que, _res$topics;

        var res = this.answers[required[i].id]; // take response to be missing if null, undefined, empty string or empty [] or {}; with
        // other falsy answers (e.g. 0, false) accepted. If not, if a question asked for a number
        // and 0 was left, we'd consider that not an answer to a question with required = true.

        if (res === null || typeof res === 'undefined' || typeof res === 'string' && res.trim() === '' || _typeof(res) === 'object' && !Object.keys(res).length) {
          return false;
        } // Question type-specific required validation:


        var questionType = (_required$i$_meta$que = required[i]._meta.question) === null || _required$i$_meta$que === void 0 ? void 0 : _required$i$_meta$que.questionType;

        if (questionType === FIB.QUESTION_TYPE.QUESTION_TYPE_DRILLDOWN_PLUS && (res === null || res === void 0 ? void 0 : (_res$topics = res.topics) === null || _res$topics === void 0 ? void 0 : _res$topics.length) === 0) {
          return false;
        }
      } // if all responses present and valid, return true


      return true;
    },
    handleScroll: function handleScroll() {
      var _this4 = this;

      // watching scroll is bad for performance, so we return early wherever possible
      if (this.screensToDisplay.length === 1) {
        this.currentViewableScreen = 0;
        this.showPinnedHeader = false;
        return;
      }

      var screenElements = this.$refs.screens;

      if (!screenElements || !screenElements.length) {
        return;
      }

      var currentScrollPosition = window.pageYOffset;
      var showPinnedHeader = false;
      Array.from(screenElements).forEach(function (screen, index) {
        // I have added a larger pixel buffer here to hopefully eliminate some unwanted behaviours on mobile devices
        var screenTop = screen.$el.offsetTop + _this4.brandedSectionHeight - 100;
        var screenBottom = screenTop + screen.$el.offsetHeight;

        if (currentScrollPosition < screenBottom && currentScrollPosition >= screenTop) {
          _this4.currentViewableScreen = index;
        }

        if (currentScrollPosition < screenBottom - 180 && currentScrollPosition >= screenTop + 125) {
          showPinnedHeader = true;
        }
      });
      this.showPinnedHeader = showPinnedHeader;
    },
    showNextScreen: function showNextScreen() {
      var _arguments = arguments,
          _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _this5$$store$getters2;

        var skip, self, name, _this5$currentSurvey, surveyId, surveyTypeId, branchId, sectionAlreadyCompleted, _this5$$store$getters, skippedSections;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                skip = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : false;
                self = _this5;
                _this5.nextScreenTriggerLoading = true;
                name = _this5.companyDetails.name;
                _this5$currentSurvey = _this5.currentSurvey, surveyId = _this5$currentSurvey.surveyId, surveyTypeId = _this5$currentSurvey.surveyTypeId;
                branchId = _this5.branchDetails.id;
                sectionAlreadyCompleted = _this5.completedScreens.find(function (screen) {
                  return screen.section.name === _this5.latestScreen.section.name;
                }); // pass the result from checking if the screen has already been completed when dispatching addCompletedScreen store action

                _context2.next = 9;
                return _this5.$store.dispatch('questions/addCompletedScreen', {
                  screen: _this5.latestScreen,
                  alreadyComplete: sectionAlreadyCompleted
                });

              case 9:
                if (skip) {
                  skipSection({
                    companyName: name,
                    surveyId: surveyId,
                    surveyTypeId: surveyTypeId,
                    section: _this5.latestScreen,
                    branchId: branchId,
                    isPveUser: !!((_this5$$store$getters = _this5.$store.getters['checkIn/urlParams']) !== null && _this5$$store$getters !== void 0 && _this5$$store$getters.pve)
                  });
                } // otherwise, check if there are more screens which need to be loaded into the DOM


                if (!(_this5.currentViewableScreen < _this5.finalScreenIndex)) {
                  _context2.next = 15;
                  break;
                }

                // increment the current index to add the next screen to the DOM
                _this5.currentViewableScreen++;
                _this5.latestScreenIndex = _this5.currentViewableScreen; // FC were putting in an arbitrary timeout to allow the DOM to update - I have used the Vue $nextTick function to wait for the next rendering cycle, which will greatly improve UX and should solve some of the double click problems

                _this5.$nextTick(function () {
                  self.scrollToLatestScreen();
                });

                return _context2.abrupt("return");

              case 15:
                _this5.nextScreenTriggerLoading = false; // submit the survey response to the api now (at least on the web) as soon as possible,
                // so that if the guest quits out of the survey early, we have captured as much information as possible.

                _this5.$store.dispatch('responses/submit'); // calculate what sections were skipped (no answers for those sections)


                skippedSections = _this5.currentSurvey.sections.filter(function (section) {
                  return !_this5.answeredSections.includes(section.name);
                }).map(function (section) {
                  return section.name;
                }); // google analytics track submit survey

                surveySubmitted({
                  companyName: name,
                  surveyId: surveyId,
                  surveyTypeId: surveyTypeId,
                  sectionsCompleted: _this5.answeredSections.length,
                  sectionsCompletedNames: _this5.answeredSections,
                  sectionsSkipped: skippedSections.length,
                  sectionsSkippedNames: skippedSections,
                  sectionsTotal: _this5.currentSurvey.sections.length,
                  answeredCount: Object.keys(_this5.answers).length,
                  totalQuestionsCount: _this5.totalQuestionsCount,
                  branchId: branchId,
                  isPveUser: !!((_this5$$store$getters2 = _this5.$store.getters['checkIn/urlParams']) !== null && _this5$$store$getters2 !== void 0 && _this5$$store$getters2.pve)
                });

              case 19:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    scrollToLatestScreen: function scrollToLatestScreen() {
      var index = String(this.currentViewableScreen);
      var element = ".screen-".concat(index);
      var scrollTarget = document.querySelector(element);

      if (scrollTarget) {
        scrollTarget.scrollIntoView({
          behavior: 'smooth'
        });
        this.nextScreenTriggerLoading = false;
      }
    },
    getSubQuestions: function getSubQuestions(question, key) {
      var required = [];

      if (question.props && question.props[key]) {
        question.props[key].forEach(function (element) {
          if (element.subQuestions) {
            required = [].concat(_toConsumableArray(required), _toConsumableArray(element.subQuestions.map(function (q) {
              return q.id;
            })));
          }
        });
      }

      return required;
    },
    validateScreens: function validateScreens() {
      var _this6 = this;

      // this may require additional validation rules
      var validScreens = {};
      this.screensToDisplay.forEach(function (screen, index) {
        var valid = true;

        if (screen && screen.questions && screen.questions.length) {
          // check that all required questions have been answered
          var requiredQuestions = [];
          screen.questions.map(function (question) {
            if (question.type === 'fib-staff-selection') {// presumably these aren't required?
            } else if (question.type === 'fib-overall-experience') {
              var subQuestions = _this6.getSubQuestions(question, 'services');

              requiredQuestions = subQuestions;
            } else if (question.type === 'fib-dish-selection-epos') {
              var _subQuestions = _this6.getSubQuestions(question, 'dishes');

              requiredQuestions = _subQuestions;
            } else if (question.type === 'fib-dish-selection-manual') {// these can't be required, because we don't know what they ate
            } else if (question.required) {
              requiredQuestions.push(question.id);
            }
          });
          valid = requiredQuestions.every(function (id) {
            var answer = _this6.answers[id];
            var answered = !!answer;

            if (answered && Array.isArray(answer) && !answer.length) {
              answered = false;
            }

            return answered;
          });
        }

        validScreens[index] = valid;
      });
      this.validScreens = validScreens;
    }
  },
  unmounted: function unmounted() {
    window.removeEventListener('scroll', this.handleScroll);
  }
};